import { Component, OnInit } from '@angular/core';

import { ProductOpenenDirective } from '../product-openen/product-openen.directive';
import { DistributionChannelType } from '../product-openen/product-openen.model';

@Component({
    selector: 'retail-product-openen',
    templateUrl: './retail-product-openen.component.html',
    standalone: false
})
export class RetailProductOpenenComponent extends ProductOpenenDirective implements OnInit {
    public ngOnInit(): void {
        super.ngOnInit();
        this.content.DistributionChannelType = DistributionChannelType.RETAIL;
    }
}
